import './src/vaadin-icon.js';

export * from './src/vaadin-icon-svg.js';
export * from './src/vaadin-icon.js';
